import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/common/page-header";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { CreateTenantForm } from "@/components/tenants/CreateTenantForm";

// ============================================================================
// Component
// ============================================================================

export function CreateTenantPage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 max-w-3xl">
      <PageHeader
        title="Create New Tenant"
        subtitle="Set up a new tenant account with resource quotas"
        back={{
          label: "Back to Tenants",
          onClick: () => navigate("/admin/tenants"),
        }}
      />

      {/* Form Card */}
      <Card>
        <CardHeader>
          <CardTitle>Tenant Details</CardTitle>
          <CardDescription>
            Enter the tenant's information and configure initial resource quotas
          </CardDescription>
        </CardHeader>
        <CardContent>
          <CreateTenantForm />
        </CardContent>
      </Card>
    </div>
  );
}
